import React from 'react';
import fetch from 'common/services/fetch';
import store from 'common/services/storage';
import utils from 'common/utils';
import './userLogin.scss';

class UserLoginView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: '',
      password: '',
    };
    this.checkLogin();
    this.login = this.login.bind(this);
    this.handleMobile = this.handleMobile.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
    document.title = '麦淘供应商';
  }
  /* eslint-disable */
  checkLogin() {
    const uid = store.get('LOGIN_UID');
    if (!utils.isEmpty(uid)) {
      const ref = store.get('loginRef', true);
      if (utils.isEmpty(ref)) {
        location.replace('/saleConfirm');
      } else {
        location.replace(ref);
      }
    }
  }
  handleMobile(e) {
    this.setState({
      mobile: e.target.value,
    });
  }
  handlePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }
  /* eslint-disable */
  login() {
    fetch.get('/partner/bend/login/by/password', {
      mobile: this.state.mobile,
      password: this.state.password,
    }).then((res) => {
      store.set('LOGIN_UID', res.partnerId);
      store.set('MT_TOKEN', res.token)
      const ref = store.get('loginRef', true);
      if (utils.isEmpty(ref)) {
        location.href = '/saleConfirm';
      } else {
        location.replace(ref);
      }
    });
  }
  blurHandler() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className='userLoginView'>
        <img src={require('assets/images/icon-login-main.png')} className='mainLogo'/>
        <div className='loginForm'>
          <div className='formItem'>
            <i className="icon"><img src='https://img.maitao.com/27d30015-8d35-40b3-bea2-4f08ec042add.jpg' width='23' height='42'/></i>
            <input placeholder="请输入手机号" value={this.state.mobile} onChange={this.handleMobile} onBlur={this.blurHandler}/>
          </div>
          <div className='formItem'>
            <i className="icon"><img src='https://img.maitao.com/d1565006-654e-4853-af61-f00124a29c0d.jpg' width='29' height='39'/></i>
            <input placeholder="请输入密码" type='password' value={this.state.password} onChange={this.handlePassword}  onBlur={this.blurHandler}/>
          </div>
        </div>
        <div onClick={this.login} className='loginButton'>
         登录
        </div>
      </div>
    );
  }
}
export default UserLoginView;
